module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ce-Db-Ef.3a73dec6.png";